import Vue from 'vue';
import Vuex from 'vuex';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

Vue.use(Vuex);
const state = {
    appTheme: null,   // 当前主题 1新版暗色、2经典
    userInfo: {},
    systemInfo: {},   // 系统信息

    documentSize: {}, // 目前包含document的宽和高

    forLevelMenu:[],        //适用级别
    examFormMenu:[],    //考核形式
    trainTypeMenu:[],   //培训类别
    trainSpecialMenu: [], //培训专题
    trainModeMenu: [], //培训模式（线上、线下）
    groupMenu:[],
    positionMenu:[],
    userTypeMenu: [],   //身份类型：(管理员、培训师...)
    orgTree: [],        //组织机构
    courseTypeMenu:[],
    paperTypeMenu:[],
    topicTypeMenu: [],  //（单选、多选、判断...）
    paperMethodMenu: [],
    difficultyMenu: [], //难易程度
    examStatusMenu: [], //考试状态
    certTypesMenu: [], //证书类型
    preJobMenu: [], //开岗放权
    viewCountMenu: [], // 图像视角
    imageOriginMenu: [], // 图像来源
    ledgerOriginMenu: [], // 台账来源

    //全部知识点
    knowledgeMenu: {
        'All': [],
        'Theory': [],
        'Image': []
    },
    //图库知识点
    systemKnowledgeMenu: {
        'All': [],
        'Theory': [],
        'Image': []
    },
    //标记知识点
    markKnowledgeMenu: [],

    uploadTop:[], //上传次数排名
    projectTypeMenu:[], //项目类型
    knowledgeTypeMenu:[], //知识类型
    creditTypeMenu:[], //学分类型
    rankTypeMenu:[], //学分类型
    fiscanProductMenu:[], //职鉴图像设备型号

    userTrainSetting: {},

    wsBrowser: null,
    wsTrainee: null,
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions,
})


